@if (cookieConsent.shouldShowBanner()) {
	<aside
		class="cookie-consent-bar"
		role="region"
		aria-labelledby="cookieConsent-title"
		data-automation-id="cookieConsent-banner"
	>
		<div class="cookie-consent-bar__text">
			<p
				id="cookieConsent-title"
				class="cookie-consent-bar__title"
				i18n="Cookie consent banner title@@cookieConsent-title"
			>
				We use cookies
			</p>
			<p class="cookie-consent-bar__message" data-automation-id="cookieConsent-message">
				<span i18n="Cookie consent banner body@@cookieConsent-message"
					>We use essential cookies to run SentriKey Access+. With your permission, we also use analytics cookies to
					understand how the product is used. Your choice does not affect access.</span
				>
				&nbsp;
				<span i18n="@@cookieConsent-nonUS">Non-US</span>
				|
				<a
					class="cookie-consent-bar__link"
					[href]="nonUsPrivacyPolicyUrl"
					appExternalLink
					i18n="@@cookieConsent-privacyPolicy"
					data-automation-id="cookieConsent-privacy-policy-non-us"
					>Privacy Policy</a
				>
				&nbsp;
				<span i18n="@@cookieConsent-US">US</span>
				|
				<a
					class="cookie-consent-bar__link"
					[href]="usPrivacyPolicyUrl"
					appExternalLink
					i18n="@@cookieConsent-privacyPolicy"
					data-automation-id="cookieConsent-privacy-policy-us"
					>Privacy Policy</a
				>
			</p>
		</div>
		<div class="cookie-consent-bar__actions">
			<button
				mat-stroked-button
				type="button"
				class="cookie-consent-bar__reject"
				(click)="cookieConsent.reject()"
				i18n="Cookie consent reject@@cookieConsent-reject"
				data-automation-id="cookieConsent-reject-button"
			>
				Reject
			</button>
			<button
				mat-flat-button
				type="button"
				class="cookie-consent-bar__accept"
				(click)="cookieConsent.accept()"
				i18n="Cookie consent accept all@@cookieConsent-acceptAll"
				data-automation-id="cookieConsent-accept-button"
			>
				Accept All
			</button>
		</div>
	</aside>
}
